/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemNote } from '../../models/system-note';
import { SystemNoteDto } from '../../models/system-note-dto';

export interface AddSystemNote$Params {
      body: SystemNoteDto
}

export function addSystemNote(http: HttpClient, rootUrl: string, params: AddSystemNote$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemNote>> {
  const rb = new RequestBuilder(rootUrl, addSystemNote.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemNote>;
    })
  );
}

addSystemNote.PATH = '/api/system/note';
